import { render, staticRenderFns } from "./AiAssistantPrompts.vue?vue&type=template&id=45f000c2&scoped=true&"
import script from "./AiAssistantPrompts.vue?vue&type=script&lang=js&"
export * from "./AiAssistantPrompts.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistantPrompts.vue?vue&type=style&index=0&id=45f000c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f000c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f000c2')) {
      api.createRecord('45f000c2', component.options)
    } else {
      api.reload('45f000c2', component.options)
    }
    module.hot.accept("./AiAssistantPrompts.vue?vue&type=template&id=45f000c2&scoped=true&", function () {
      api.rerender('45f000c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/modal/AiAssistantDrawer/AiAssistantPrompts.vue"
export default component.exports